var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("我是自定义头部")]),_vm._v(" "),_c('h4',[_vm._v("我是element ui")]),_vm._v(" "),_c('el-button',[_vm._v("默认按钮")]),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('div',[_vm._v("我是自定义尾部")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }